import { module as BaseModule } from 'modujs'
import { gsap } from 'gsap'

const isEmail = (email) => {
  const re = /\S+@\S+\.\S+/
  return re.test(email)
}

export default class extends BaseModule {
  init() {
    this.inputWrapper = this.el.querySelector('[data-footer-input]')
    this.emailInput = this.el.querySelector('input[type="email"]')
    this.submitButton = this.el.querySelector('button')
    this.notice = this.el.querySelector('.notice')
    this.state = false

    this.submitButton.addEventListener('click', (e) => {
      const isValid = isEmail(this.emailInput.value)

      this.notice.classList.toggle('opacity-0', isValid)
      if (!isValid) {
        if (!this.state) {
          this.state = true
          gsap.to(this.inputWrapper, {
            x: -10,
            duration: 0.1,
            repeat: 5,
            yoyo: true,
            overwrite: true,
            onComplete: () => {
              this.state = false
            },
          })
        }
        e.preventDefault()
      }
    })
  }
}
